export default __webpack_public_path__ + "imgs/609600fcee548ae16159e99bce8f1b4a.jpg";